// Configuration de l'API - CORRECTION ICI  
// src\api.js
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';

console.log('Configuration API:', {
    apiUrl: process.env.REACT_APP_API_URL,
    baseUrl: API_BASE_URL,
    nodeEnv: process.env.NODE_ENV
});

// Headers par défaut
const getHeaders = (includeAuth = true) => {
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };
    
    if (includeAuth) {
        const token = localStorage.getItem('token');
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
    }
    
    return headers;
};

// Fonction utilitaire pour les requêtes
const apiRequest = async (endpoint, method = 'GET', data = null, includeAuth = true) => {
    const url = `${API_BASE_URL}${endpoint}`;
    console.log(`API Request: ${method} ${url}`);
    
    const options = {
        method,
        headers: getHeaders(includeAuth),
    };
    
    if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
        if (data instanceof FormData) {
            // Pour les FormData (upload de fichiers)
            delete options.headers['Content-Type'];
            options.body = data;
        } else {
            options.body = JSON.stringify(data);
        }
    }
    
    try {
        const response = await fetch(url, options);
        console.log(`Response Status: ${response.status}`);
        
        // Gérer les réponses non JSON (comme 204 No Content)
        if (response.status === 204) {
            return { success: true };
        }
        
        // Vérifier si la réponse est JSON
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
            throw {
                status: response.status,
                message: 'Réponse non JSON du serveur',
                contentType: contentType
            };
        }
        
        const responseData = await response.json();
        
        if (!response.ok) {
            throw {
                status: response.status,
                message: responseData.message || 'Une erreur est survenue',
                errors: responseData.errors || null,
                data: responseData
            };
        }
        
        return responseData;
    } catch (error) {
        console.error('API Error:', error);
        
        if (error.status) {
            throw error;
        }
        
        // Si c'est une erreur de parsing JSON
        if (error.message && error.message.includes('JSON')) {
            throw {
                status: 500,
                message: 'Le serveur a retourné une réponse invalide (non JSON)',
                error: error.message
            };
        }
        
        throw {
            status: 500,
            message: 'Erreur de connexion au serveur',
            error: error.message
        };
    }
};

// ==================== AUTHENTIFICATION ====================
export const authAPI = {
    // Inscription
    register: async (userData) => {
        return apiRequest('/register', 'POST', userData, false);
    },
    
    // Connexion
    login: async (credentials) => {
        return apiRequest('/login', 'POST', credentials, false);
    },
    
    // Déconnexion
    logout: async () => {
        return apiRequest('/auth/logout', 'POST');
    },
    
    // Profil utilisateur
    getProfile: async () => {
        return apiRequest('/auth/me', 'GET');
    },
    
    // Mettre à jour le profil
    updateProfile: async (profileData) => {
        return apiRequest('/auth/profile', 'PUT', profileData);
    },
    
    // Changer le mot de passe
    changePassword: async (passwordData) => {
        return apiRequest('/auth/change-password', 'PUT', passwordData);
    },
    
    // Rafraîchir le token
    refreshToken: async () => {
        return apiRequest('/auth/refresh', 'POST');
    }
};

// ==================== BLOGS ====================
export const blogAPI = {
    // Récupérer tous les blogs (public) - CORRECTION ICI
// Dans blogAPI.getAll, avant de retourner la réponse
getAll: async (page = 1) => {
    try {
        const response = await apiRequest(`/blogs?page=${page}`, 'GET', null, false);
        console.log('RAW API Response:', response); // Voir la réponse brute
        return response;
    } catch (error) {
        console.error('Error in blogAPI.getAll:', error);
        throw error;
    }
},
    // Récupérer un blog par ID (public) - CORRECTION ICI
    getById: async (id) => {
        try {
            const response = await apiRequest(`/blogs/${id}`, 'GET', null, false);
            
            // AJOUTER : Normaliser l'URL de l'image pour le détail
            if (response.success && response.data) {
                const blog = response.data;
                if (blog.image) {
                    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
                    
                    if (blog.image.startsWith('http')) {
                        blog.image_url = blog.image;
                    } else {
                        const fileName = blog.image.split('/').pop();
                        blog.image_url = `${baseUrl}/api/storage/blogs/${fileName}`;
                    }
                } else {
                    blog.image_url = '/default-blog.jpg';
                }
                
                // Vérifier aussi image_url du backend
                if (blog.image_url && !blog.image_url.startsWith('http') && !blog.image_url.startsWith('/')) {
                    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
                    blog.image_url = `${baseUrl}/api/storage/${blog.image_url}`;
                }
            }
            
            return response;
        } catch (error) {
            console.error('Error in blogAPI.getById:', error);
            throw error;
        }
    },
    
    // Récupérer un blog par slug (public) - CORRECTION ICI
    getBySlug: async (slug) => {
        try {
            const response = await apiRequest(`/blogs/slug/${slug}`, 'GET', null, false);
            
            // AJOUTER : Normaliser l'URL de l'image pour le détail par slug
            if (response.success && response.data) {
                const blog = response.data;
                if (blog.image) {
                    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
                    
                    if (blog.image.startsWith('http')) {
                        blog.image_url = blog.image;
                    } else {
                        const fileName = blog.image.split('/').pop();
                        blog.image_url = `${baseUrl}/api/storage/blogs/${fileName}`;
                    }
                } else {
                    blog.image_url = '/default-blog.jpg';
                }
                
                // Vérifier aussi image_url du backend
                if (blog.image_url && !blog.image_url.startsWith('http') && !blog.image_url.startsWith('/')) {
                    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
                    blog.image_url = `${baseUrl}/api/storage/${blog.image_url}`;
                }
            }
            
            return response;
        } catch (error) {
            console.error('Error in blogAPI.getBySlug:', error);
            throw error;
        }
    },
    
    // Créer un blog (admin)
    create: async (blogData) => {
        return apiRequest('/blogs', 'POST', blogData);
    },
    
    // Mettre à jour un blog (admin)
    update: async (id, blogData) => {
        return apiRequest(`/blogs/${id}`, 'PUT', blogData);
    },
    
    // Supprimer un blog (admin)
    delete: async (id) => {
        return apiRequest(`/blogs/${id}`, 'DELETE');
    },
    
    // Mes blogs (utilisateur connecté)
    getMyBlogs: async (page = 1) => {
        return apiRequest(`/my-blogs?page=${page}`, 'GET'); 
    },
    
    // Upload d'image pour blog
    uploadImage: async (imageFile) => {
        const formData = new FormData();
        formData.append('image', imageFile);
        
        const url = `${API_BASE_URL}/blogs/upload-image`;
        console.log('Upload Image to:', url);
        
        const options = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
            body: formData
        };
        
        try {
            const response = await fetch(url, options);
            return response.json();
        } catch (error) {
            console.error('Upload error:', error);
            throw error;
        }
    }
};

// ==================== ÉVÉNEMENTS ====================
export const eventAPI = {
    // Récupérer tous les événements (public)
    getAll: async (page = 1) => {
        try {
            const response = await apiRequest(`/events?page=${page}`, 'GET', null, false);
            
            console.log('Event API Response:', response);
            
            // CORRECTION POUR PRODUCTION
            if (response.success && response.data && response.data.data && Array.isArray(response.data.data)) {
                response.data.data = response.data.data.map(event => {
                    if (event.image) {
                        const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
                        const isProduction = baseUrl.includes('etef.fr');
                        
                        if (event.image.startsWith('http')) {
                            event.image_url = event.image;
                        } else {
                            // Extraire le nom du fichier
                            const fileName = event.image.split('/').pop();
                            
                            if (isProduction) {
                                // EN PRODUCTION: Utiliser le lien direct
                                event.image_url = `${baseUrl}/storage/events/${fileName}`;
                            } else {
                                // EN LOCAL: Utiliser l'API
                                event.image_url = `${baseUrl}/api/storage/events/${fileName}`;
                            }
                            
                            console.log(`Event ${event.id}: Built image URL: ${event.image_url} from path: ${event.image}`);
                        }
                    } else {
                        event.image_url = '/default-event.jpg';
                    }
                    
                    return event;
                });
            }
            
            return response;
        } catch (error) {
            console.error('Error in eventAPI.getAll:', error);
            throw error;
        }
    },
    
    // Récupérer un événement par ID (public) - Même correction
    getById: async (id) => {
        try {
            const response = await apiRequest(`/events/${id}`, 'GET', null, false);
            
            if (response.success && response.data) {
                const event = response.data;
                if (event.image) {
                    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
                    
                    if (event.image.startsWith('http')) {
                        event.image_url = event.image;
                    } else {
                        const fileName = event.image.split('/').pop();
                        event.image_url = `${baseUrl}/api/storage/events/${fileName}`; // ← ICI
                    }
                } else {
                    event.image_url = '/default-event.jpg';
                }
                
                // Vérifier aussi image_url du backend
                if (event.image_url && !event.image_url.startsWith('http') && !event.image_url.startsWith('/')) {
                    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
                    event.image_url = `${baseUrl}/api/storage/${event.image_url}`; // ← ICI
                }
            }
            
            return response;
        } catch (error) {
            console.error('Error in eventAPI.getById:', error);
            throw error;
        }
    },
    
    // Récupérer un événement par slug (public) - Même correction
    getBySlug: async (slug) => {
        try {
            const response = await apiRequest(`/events/slug/${slug}`, 'GET', null, false);
            
            if (response.success && response.data) {
                const event = response.data;
                if (event.image) {
                    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
                    
                    if (event.image.startsWith('http')) {
                        event.image_url = event.image;
                    } else {
                        const fileName = event.image.split('/').pop();
                        event.image_url = `${baseUrl}/api/storage/events/${fileName}`; // ← ICI
                    }
                } else {
                    event.image_url = '/default-event.jpg';
                }
                
                // Vérifier aussi image_url du backend
                if (event.image_url && !event.image_url.startsWith('http') && !event.image_url.startsWith('/')) {
                    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
                    event.image_url = `${baseUrl}/api/storage/${event.image_url}`; // ← ICI
                }
            }
            
            return response;
        } catch (error) {
            console.error('Error in eventAPI.getBySlug:', error);
            throw error;
        }
    },
    
    // Créer un événement (admin)
    create: async (eventData) => {
        return apiRequest('/events', 'POST', eventData);
    },
    
    // Mettre à jour un événement (admin)
    update: async (id, eventData) => {
        return apiRequest(`/events/${id}`, 'PUT', eventData);
    },
    
    // Supprimer un événement (admin)
    delete: async (id) => {
        return apiRequest(`/events/${id}`, 'DELETE');
    },
    
    // Mes événements (utilisateur connecté)
    getMyEvents: async (page = 1) => {
        return apiRequest(`/my-events?page=${page}`, 'GET');
    },
    
    // Événements à venir
    getUpcoming: async (limit = 5) => {
        return apiRequest(`/events/upcoming?limit=${limit}`, 'GET', null, false);
    }
};

// ==================== CONTACTS ====================
// ==================== CONTACTS ====================
export const contactAPI = {
    // Envoyer un message (public)
    sendMessage: async (contactData) => {
        return apiRequest('/contact', 'POST', contactData, false);
    },
    
    // Récupérer tous les messages (admin)
    getAll: async (page = 1) => {
        return apiRequest(`/contact?page=${page}`, 'GET', null, true);
    },
    
    // Récupérer un message (admin)
    getById: async (id) => {
        return apiRequest(`/contact/${id}`, 'GET', null, true);
    },
    
    // Marquer comme lu (admin) - Utiliser POST sur /contact/{id}/mark-read
    markAsRead: async (id) => {
        return apiRequest(`/contact/${id}/mark-read`, 'POST', null, true);
    },
    
    // Marquer comme non lu (admin) - Utiliser POST sur /contact/{id}/mark-unread
    markAsUnread: async (id) => {
        return apiRequest(`/contact/${id}/mark-unread`, 'POST', null, true);
    },
    
    // Supprimer un message (admin)
    delete: async (id) => {
        return apiRequest(`/contact/${id}`, 'DELETE', null, true);
    },
    
    // Compter les messages non lus (admin)
    getUnreadCount: async () => {
        return apiRequest('/contact/unread/count', 'GET', null, true);
    },
    
    // Récupérer les messages non lus (admin)
    getUnreadMessages: async (page = 1) => {
        return apiRequest(`/contact/unread/messages?page=${page}`, 'GET', null, true);
    }
};

// ==================== UTILITAIRES ====================
export const utilsAPI = {
    // Vérifier la connexion
    checkConnection: async () => {
        try {
            await apiRequest('/blogs', 'GET', null, false);
            return true;
        } catch (error) {
            console.error('Connection check failed:', error);
            return false;
        }
    },
    
    // Stocker le token
    setToken: (token) => {
        localStorage.setItem('token', token);
        console.log('Token stored');
    },
    
    // Récupérer le token
    getToken: () => {
        return localStorage.getItem('token');
    },
    
    // Supprimer le token
    removeToken: () => {
        localStorage.removeItem('token');
        console.log('Token removed');
    },
    
    // Vérifier si l'utilisateur est connecté
    isAuthenticated: () => {
        return !!localStorage.getItem('token');
    },
    
    // Vérifier les variables d'environnement
    getEnvInfo: () => {
        return {
            apiUrl: process.env.REACT_APP_API_URL,
            nodeEnv: process.env.NODE_ENV,
            baseUrl: API_BASE_URL
        };
    }
};

// Export par défaut
export default {
    auth: authAPI,
    blog: blogAPI,
    event: eventAPI,
    contact: contactAPI,
    utils: utilsAPI
};